export enum TemplateActionTypes {
    GET_TEMPLATES_REQUEST   = "@@template/GET_TEMPLATES_REQUEST",
    GET_TEMPLATES_SUCCESS   = "@@template/GET_TEMPLATES_SUCCESS",
    GET_TEMPLATES_ERROR     = "@@template/GET_TEMPLATES_ERROR",
  
    GET_TEMPLATE_REQUEST    = "@@template/GET_TEMPLATE_REQUEST",
    GET_TEMPLATE_SUCCESS    = "@@template/GET_TEMPLATE_SUCCESS",
    GET_TEMPLATE_ERROR      = "@@template/GET_TEMPLATE_ERROR",
  
    CREATE_TEMPLATE_REQUEST = "@@template/CREATE_TEMPLATE_REQUEST",
    CREATE_TEMPLATE_SUCCESS = "@@template/CREATE_TEMPLATE_SUCCESS",
    CREATE_TEMPLATE_ERROR   = "@@template/CREATE_TEMPLATE_ERROR",
  
    UPDATE_TEMPLATE_REQUEST = "@@template/UPDATE_TEMPLATE_REQUEST",
    UPDATE_TEMPLATE_SUCCESS = "@@template/UPDATE_TEMPLATE_SUCCESS",
    UPDATE_TEMPLATE_ERROR   = "@@template/UPDATE_TEMPLATE_ERROR",
  
    DELETE_TEMPLATE_REQUEST = "@@template/DELETE_TEMPLATE_REQUEST",
    DELETE_TEMPLATE_SUCCESS = "@@template/DELETE_TEMPLATE_SUCCESS",
    DELETE_TEMPLATE_ERROR   = "@@template/DELETE_TEMPLATE_ERROR",
  }
  
  export interface TemplateSummaryDto {
    id: string;
    name: string;
    channelType: "EMAIL" | "SMS" | "IN_APP";
    updatedAt: string;
  }
  
  export interface TemplateDetailDto extends TemplateSummaryDto {
    subject?: string;
    bodyHtml?: string;
    plainText?: string;
    title?: string;
    iconUrl?: string;
    deepLinkTemplate?: string;
  }
  
  export interface TemplateState {
    list: TemplateSummaryDto[];
    current?: TemplateDetailDto;
    loading: boolean;
    error: string | null;
  }
  